import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import * as stylex from "@stylexjs/stylex";
import Text from "noood/comp/text/Text";
import { string_util } from "noood/util/string/StringUtil";
import Icon from "noood/comp/ui/feather-icon/Icon";
export default function ObjectViewer(props) {
  var _Object$keys;
  var __fuzzyMatch = function __fuzzyMatch(property) {
    if (property.match(/\s?id|quantity/i)) return "hash";
    if (property.match(/(username|name)/)) return "tag";
    if (property.match(/(description|desc)/)) return "menu";
    if (property.match(/(address|location)/)) return "map-pin";
    if (property.match(/(_dt|_date)/)) return "calendar";
    if (property.match(/(status)/)) return "loader";
    if (property.match(/(img|image|picture)/)) return "image";
    if (property.match(/(_by)/)) return "user";
    if (property.match(/(price|amount)/)) return "money-bill";
    if (property.match(/^(del)$/)) return "trash-2";
    if (property.match(/^(hierarchy)$/)) return "arrow-up";
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '2px'
    }
  }, props.obj ? /*#__PURE__*/React.createElement("table", {
    className: "ObjectViewer__ui.table evh8yej3 ev1vathgz ev1gukg7c evxwrc4x evb3r6kr"
  }, /*#__PURE__*/React.createElement("tbody", null, (_Object$keys = Object.keys(props.obj)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (prop, idx) {
    var _props$obj, _props$fields, _ref, _props$fields$prop$ic, _props$fields2, _props$label_width, _props$fields$prop$la, _props$fields3;
    var field = (_props$obj = props.obj) === null || _props$obj === void 0 ? void 0 : _props$obj[prop];
    var fieldOverride = (_props$fields = props.fields) === null || _props$fields === void 0 ? void 0 : _props$fields[prop];
    return /*#__PURE__*/React.createElement("tr", _extends({
      key: idx
    }, stylex.props(idx % 2 === 0 ? ui.even : ui.odd)), /*#__PURE__*/React.createElement("td", _extends({
      style: {
        width: '10px'
      }
    }, {
      className: "ObjectViewer__ui.cell ev14odnwx"
    }), /*#__PURE__*/React.createElement(Icon, {
      icon: (_ref = (_props$fields$prop$ic = (_props$fields2 = props.fields) === null || _props$fields2 === void 0 || (_props$fields2 = _props$fields2[prop]) === null || _props$fields2 === void 0 ? void 0 : _props$fields2.icon) !== null && _props$fields$prop$ic !== void 0 ? _props$fields$prop$ic : __fuzzyMatch(prop)) !== null && _ref !== void 0 ? _ref : 'maximize'
    })), /*#__PURE__*/React.createElement("td", {
      style: {
        width: (_props$label_width = props.label_width) !== null && _props$label_width !== void 0 ? _props$label_width : 150
      }
    }, /*#__PURE__*/React.createElement(Text, {
      secondary: true
    }, (_props$fields$prop$la = (_props$fields3 = props.fields) === null || _props$fields3 === void 0 || (_props$fields3 = _props$fields3[prop]) === null || _props$fields3 === void 0 ? void 0 : _props$fields3.label) !== null && _props$fields$prop$la !== void 0 ? _props$fields$prop$la : string_util.uc_words(prop, '_'))), /*#__PURE__*/React.createElement("td", {
      style: {
        wordBreak: "break-all",
        fontFamily: fieldOverride !== null && fieldOverride !== void 0 && fieldOverride.isMonospace ? 'mono' : 'font1'
      }
    }, _typeof(props.obj[prop]) === 'object' ? props.obj[prop] == null ? /*#__PURE__*/React.createElement(Text, {
      secondary: true,
      italic: true
    }, "No Value") : /*#__PURE__*/React.createElement(ObjectViewer, {
      obj: props.obj[prop]
    }) : typeof props.obj[prop] === "boolean" || fieldOverride !== null && fieldOverride !== void 0 && fieldOverride.forceBoolean ? /*#__PURE__*/React.createElement("span", {
      style: {
        backgroundColor: "var(--shade-".concat(Boolean(props.obj[prop]) ? 'positive' : 'negative', ")"),
        display: "inline-block",
        borderRadius: "var(--roundness)",
        padding: "0 4px",
        color: Boolean(props.obj[prop]) ? '#333' : '#fff'
      }
    }, props.obj[prop] ? "true" : "false") : props.obj[prop]));
  }))) : null);
}

// @ts-ignore
_inject(".evh8yej3{width:100%}", 4000);
_inject(".ev1vathgz{border-collapse:separate}", 3000);
_inject(".ev1gukg7c{border-spacing:0}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".evb3r6kr{overflow:hidden}", 2000);
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".ev12qy6l{border-top-left-radius:var(--roundness)}", 4000);
_inject(".evrkmrrc{background-color:red}", 3000);
_inject(".evor0oh0{border-top-right-radius:var(--roundness)}", 4000);
_inject(".ev177i53z{background-color:lime}", 3000);
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev1kd3s2o{background-color:var(--shade-20)}", 3000);
var ui = {
  even: {
    "ObjectViewer__ui.even": "ObjectViewer__ui.even",
    backgroundColor: "evji57aj",
    $$css: true
  },
  odd: {
    "ObjectViewer__ui.odd": "ObjectViewer__ui.odd",
    backgroundColor: "ev1kd3s2o",
    $$css: true
  }
};